module.exports = __webpack_public_path__ + "img/25x25_yesil.2ff94d7b.gif";